import { render, staticRenderFns } from "./ContractServicesLegacy.vue?vue&type=template&id=77769f8e"
import script from "./ContractServicesLegacy.vue?vue&type=script&lang=js"
export * from "./ContractServicesLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports